@if (serviceaftale) {
  <section>
    <div class="quick-view__top">
      <div
        class="timestamp"
      title="Aftale sidst redigeret/oprettet {{
        serviceaftale.modifiedOn | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }
      }} af {{ serviceaftale.modifiedBy }}"
        >
        <mat-icon svgIcon="clock"></mat-icon>
        {{ serviceaftale.modifiedOn | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }} af
        {{ serviceaftale.modifiedBy }}
      </div>
      <hr />
    </div>
    <div class="quick-view__heading">
      <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
      <div class="data">
        <div class="data__lbl">Aftalenr.</div>
        <div class="data__val">
          {{ serviceaftale.kunde?.okKundeAftaleNr }}
        </div>
      </div>
      <span
        class="contract-state contract-state--active"
        [class.contract-state--active]="serviceaftale.isActive"
        [class.contract-state--inactive]="!serviceaftale.isActive"
        >
        <mat-icon [svgIcon]="getStatusIcon(serviceaftale)"></mat-icon>
        {{ serviceaftale.serviceaftaleState.text }}
      </span>
    </div>
    @if (isServiceaftaleTerminatedOrPendingTermination() || serviceaftale.endDate != null) {
      <div class="data">
        <div class="data__subrow">
          <div class="contract-state contract-state--inactive">
            <mat-icon svgIcon="alert-solid"></mat-icon>
            <span>Aftalen opsagt pr. {{ serviceaftale.endDate | date }}</span>
          </div>
        </div>
      </div>
    }
    <div class="margin--top-m">
      <app-garantiaftale-tag [serviceaftale]="serviceaftale"></app-garantiaftale-tag>
    </div>
    @if (serviceaftale?.kunde?.kundeExtendedInformation?.harLeasingAftale) {
      <div class="margin--top-m">
        <mat-chip-option class="orange-bg">
          <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
          &nbsp;Leasing
        </mat-chip-option>
      </div>
    }
    @if (serviceaftale?.kunde?.kundeExtendedInformation?.harNaervarmeAftale) {
      <div class="margin--top-m">
        <mat-chip-option class="orange-bg">
          <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
          &nbsp;Nærvarme
        </mat-chip-option>
      </div>
    }
    @if (serviceaftale?.kunde?.kundeExtendedInformation?.harGasfyrTryghedAftale) {
      <div class="margin--top-m">
        <mat-chip-option class="orange-bg">
          <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
          &nbsp;Gasfyr tryghed
        </mat-chip-option>
      </div>
    }
    @if (serviceaftale.serviceaftaleTags.length > 0) {
      <div class="data">
        <mat-chip-listbox aria-label="tags">
          @for (tag of serviceaftale.serviceaftaleTags; track tag) {
            <mat-chip-option>{{ tag.text }}</mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }
    @if (serviceaftale.serviceaftaleState.state !== serviceaftaleStateEnum.Terminated) {
      <div class="data">
        @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement && serviceaftale.naesteEftersynDate >= today) {
          <div class="data__subrow">
            <div class="data__lbl">
              <span>Næste eftersyn</span>
            </div>
            <div class="data__val">
              <span>{{ serviceaftale.naesteEftersynDate | date: 'shortDate' }}</span>
            </div>
          </div>
        }
        <!--<div class="data__subrow" *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement">
        <div class="data__lbl">Planlagt besøg</div>
        <div class="data__val"></div>
      </div>-->
    </div>
  }
  <div class="data">
    @if (serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      <div>
        <div class="data__lbl">Ingen abonnement</div>
      </div>
    }
    @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      <div>
        <div class="data__lbl">Abonnement</div>
        <div class="data__val">
          {{ serviceaftale?.serviceAbonnement?.description }}
        </div>
      </div>
    }
  </div>
  @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
    <div class="data">
      <div class="data__lbl">Tilvalg</div>
      <div class="data__val">
        @for (tilvalg of serviceaftale.tilvalg; track tilvalg) {
          <div>{{ tilvalg.name }}</div>
        }
        @if (!serviceaftale.tilvalg || serviceaftale.tilvalg.length == 0) {
          <div>Ingen tilvalg til denne aftale</div>
        }
      </div>
    </div>
  }
  <div class="data">
    <div class="data__lbl">
      @if ((serviceOrdrer$ | async)?.serviceordrer.length == 0) {
        <span>Ingen ordre lige nu</span>
      }
      @if ((serviceOrdrer$ | async)?.serviceordrer.length > 0) {
        <span>Igangværende ordre</span>
      }
    </div>
    <div class="data__val">
      @if (serviceOrdrer$ | async; as serviceOrdrer) {
        <ul>
          @for (ordre of serviceOrdrer.serviceordrer; track ordre) {
            <li>
              <a [routerLink]="['/ordre', ordre.serviceordreNo, 'edit']" class="blue-dark">
                {{ ordre.deadline | date: 'dd.MM.yyyy' }} {{ ordre.opgaveDisplayText }}
              </a>
            </li>
          }
        </ul>
      }
      @if (serviceaftale.serviceaftaleState.state != serviceaftaleStateEnum.Terminated) {
        <button
          type="button"
          class="btn-icon blue btn-add-small"
          [matMenuTriggerFor]="menu"
          >
          <mat-icon svgIcon="add-small"></mat-icon>
          <span>Opret ny serviceordre</span>
        </button>
      }
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="createTilkald()" [disabled]="!canWrite">Tilkald</button>
        @if (canCreateEftersyn) {
          <button mat-menu-item (click)="createEftersyn()" [disabled]="!canWrite">Eftersyn</button>
        }
        <button mat-menu-item (click)="createOpstart()" [disabled]="!canWrite">Opstart</button>
      </mat-menu>
    </div>
  </div>
  <div class="data">
    <div class="data__lbl">
      @if (remarkToServicereport) {
        <span>Bemærkning til servicerapport</span>
      }
      @if (!remarkToServicereport) {
        <span>Ingen bemærkning til servicerapport</span>
      }
    </div>
    @if (remarkToServicereport) {
      <div class="data__val">
        {{ remarkToServicereport }}
      </div>
    }
  </div>
  <ng-container>
    @if (serviceaftale.anlaeg) {
      <div>
        <hr />
        <div class="data">
          <div class="data__subrow">
            <div class="data__lbl">Fabrikat</div>
            <div class="data__val">
              {{ serviceaftale.anlaeg.fabrikat ? serviceaftale.anlaeg.fabrikat.name : serviceaftale.anlaeg.alternativFabrikat }}
            </div>
          </div>
          <div class="data__subrow">
            <div class="data__lbl">Model</div>
            <div class="data__val">
              {{ serviceaftale.anlaeg.model }}
            </div>
          </div>
        </div>
        <div class="data">
          @if (serviceaftale.anlaeg.installationDate) {
            <div class="data__subrow">
              <div class="data__lbl">Installations dato</div>
              <div class="data__val">
                {{ serviceaftale.anlaeg.installationDate | date: 'dd.MM.yyyy' }}
              </div>
            </div>
          }
          <div class="data__subrow">
            <div class="data__lbl">Storbrænder</div>
            <div class="data__val">
              {{ serviceaftale.anlaeg.storbraender ? 'ja' : 'nej' }}
            </div>
          </div>
        </div>
        @if (serviceaftale.anlaeg.komponenter.length > 0) {
          <div class="data">
            <div class="data__lbl">Komponenter</div>
            <div class="data__val">
              @for (komponent of serviceaftale.anlaeg.komponenter; track komponent) {
                <div>
                  {{ getKomponentType(komponent.komponentTypeId) }} ⋅ {{ komponent.model }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </ng-container>
  @if (!serviceaftale.anlaeg) {
    <div>Intet anlæg på denne serviceaftale</div>
  }
  @if (serviceaftale.kunde) {
    <hr />
    <div class="data">
      <div class="data__lbl">Kundenr.</div>
      <div class="data__val">
        {{ serviceaftale.kunde.okKundeNr }}
      </div>
    </div>
    <div class="data">
      <div class="data__lbl">Anlægsadresse</div>
      <div class="data__val">
        {{ serviceaftale.kunde.anlaegsadresse?.adressLine }}
      </div>
      @if (serviceaftale.kunde?.lokation) {
        <div class="data">
          <div class="data__lbl">Lokation</div>
          <div class="data__val">
            {{ serviceaftale.kunde?.lokation }}
          </div>
        </div>
      }
      @if (serviceaftale.kunde.anlaegsadresse?.name) {
        <div class="data">
          <div class="data__lbl">Navn</div>
          <div class="data__val">
            {{ serviceaftale.kunde.anlaegsadresse?.name }}
          </div>
        </div>
      }
      @if (serviceaftale.kunde.anlaegsadresse?.contact) {
        <div class="data">
          <div class="data__lbl">Kontaktperson</div>
          <div class="data__val">
            {{ serviceaftale.kunde.anlaegsadresse?.contact }}
          </div>
        </div>
      }
    </div>
    <div class="data">
      <div class="data__subrow">
        <div class="data__lbl">Telefonnr.</div>
        @if (serviceaftale.kunde.anlaegsadresse?.phone) {
          <div class="data__val">
            T: {{ $safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber }}
          </div>
        }
        @if (serviceaftale.kunde.anlaegsadresse?.mobile) {
          <div class="data__val">
            M: {{ $safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.mobile) | dkPhoneNumber }}
          </div>
        }
      </div>
      <div class="data__subrow">
        <div class="data__lbl">E-mail</div>
        <div class="data__val">
          <a
            href="mailto:{{ serviceaftale.kunde.anlaegsadresse?.email }}"
            class="ellipsis"
            title="Send mail til {{ serviceaftale.kunde.anlaegsadresse?.email }}"
            >
            {{ serviceaftale.kunde.anlaegsadresse?.email }}
          </a>
        </div>
      </div>
    </div>
  }
</section>
}
